import { Link } from "react-router-dom";
import logoBranca from "@/assets/logo-branca.webp";

interface LandingNavProps {
  onOpenAuth: () => void;
}

const LandingNav = ({ onOpenAuth }: LandingNavProps) => (
  <nav className="fixed top-0 left-0 right-0 z-50 bg-background/95 border-b border-border/30">
    <div className="container mx-auto px-5 sm:px-4 py-4 flex items-center justify-between">
      <Link to="/" className="flex flex-col items-center">
        <img src={logoBranca} alt="12 Personas de Estilo" className="h-8 md:h-10 w-auto" />
        <span className="hidden min-[600px]:block text-[10px] md:text-xs text-primary font-medium tracking-wider uppercase mt-1 text-center">
          Portal das 12 Personas de Estilo
        </span>
      </Link>

      <div className="hidden md:flex items-center gap-8">
        <a href="#sobre" className="text-muted-foreground hover:text-foreground transition-smooth">Sobre</a>
        <a href="#personas" className="text-muted-foreground hover:text-foreground transition-smooth">Personas</a>
        <a href="#funcionalidades" className="text-muted-foreground hover:text-foreground transition-smooth">Portal</a>
        <a href="#ebooks" className="text-muted-foreground hover:text-foreground transition-smooth">Ebooks</a>
        <a href="#cursos" className="text-muted-foreground hover:text-foreground transition-smooth">Cursos</a>
        <Link to="/precos" className="text-muted-foreground hover:text-foreground transition-smooth">Preços</Link>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <button
          onClick={onOpenAuth}
          className="text-muted-foreground hover:text-foreground transition-smooth text-xs sm:text-sm whitespace-nowrap px-2 py-1.5 sm:px-3 sm:py-2 rounded-md hover:bg-accent/50 text-slate-950 bg-emerald-500"
        >
          <span className="hidden min-[480px]:inline">Sou assinante</span>
          <span className="inline min-[480px]:hidden">Entrar</span>
        </button>
        <Link to="/teste" className="btn-elegant text-xs sm:text-sm px-3 py-1.5 sm:px-4 sm:py-2 whitespace-nowrap">
          Teste Express
        </Link>
      </div>
    </div>
  </nav>
);

export default LandingNav;
